import React from 'react'
import { createRoot } from 'react-dom/client';
import App from './App';

const app = document.getElementById('root');
// create a root
const root = createRoot(app);

//render app to root
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
